import React from 'react'
import { Link } from 'react-router-dom';

const beneficaries = () => {
  return (
    <main className="main-content">
    <div>
      {/* Main Content */}
      <div class="mb-6 flex flex-wrap items-center justify-between ml-4">
        <h2 class="text-xl font-semibold text-gray-800 ">
        Beneficaries
        </h2>

        <nav>
          <ol class="flex items-center gap-1.5 mr-7">
            <li>
              <Link
                class="inline-flex items-center gap-1.5 text-sm text-black "
                to="/dashboard"
              >
                Home /
              </Link>
            </li>
            <li class="text-sm text-gray-800 ">
            Beneficaries
            </li>
          </ol>
        </nav>
      </div>

      {/* Main content goes here */}

      <div class="mx-auto p-4 md:p-4">
    {/* <!-- Breadcrumb Start --> */}
    <div class="space-y-5 sm:space-y-6">
        <div class="rounded-2xl border border-gray-200 bg-white ">
            <div class="px-5 py-4 sm:px-6 sm:py-5">
                <h3 class="text-base font-medium text-gray-800 ">
                    
                </h3>
            </div>
            <div class="p-5 border-t border-gray-100  sm:p-6">
                {/* <!-- Table Start -->
                <!-- Add your table content here -->
                <!-- body Content -->
                <!-- Body content End --> */}


                <div
                class="overflow-hidden rounded-xl border border-gray-200 bg-white "
              >
                <div class="max-w-full overflow-x-auto">
                  <table class="min-w-full">
                    {/* <!-- table header start --> */}
                    <thead>
                      <tr className="text-white border-b border-gray-100  whitespace-nowrap" style={{ backgroundColor: '#635BFF'}}>
                        <th class="px-5 py-3 sm:px-6">
                          <div class="flex items-center">
                            <p
                              class="font-medium text-white text-sm "
                            >
                              SI.No
                            </p>
                          </div>
                        </th>
                        <th class="px-5 py-3 sm:px-6">
                          <div class="flex items-center">
                            <p
                              class="font-medium text-white text-sm "
                            >
                           Active Status
                            </p>
                          </div>
                        </th>
                        <th class="px-5 py-3 sm:px-6">
                          <div class="flex items-center">
                            <p
                              class="font-medium text-white text-sm "
                            >
                            Name
                            </p>
                          </div>
                        </th>
                        <th class="px-5 py-3 sm:px-6">
                          <div class="flex items-center">
                            <p
                              class="font-medium text-white text-sm "
                            >
                            Bank Name
                            </p>
                          </div>
                        </th>
                        <th class="px-5 py-3 sm:px-6">
                          <div class="flex items-center">
                            <p
                              class="font-medium text-white text-sm "
                            >
                            Account Number
                            </p>
                          </div>
                        </th>
                        <th class="px-5 py-3 sm:px-6">
                          <div class="flex items-center">
                            <p
                              class="font-medium text-white text-sm "
                            >
                            IFSC Code
                            </p>
                          </div>
                        </th>

                        <th class="px-5 py-3 sm:px-6">
                          <div class="flex items-center">
                            <p
                              class="font-medium text-white text-sm "
                            >
                            Created At
                            </p>
                          </div>
                        </th>
                        

                        
                      </tr>
                    </thead>
                    {/* <!-- table header end -->
                    <!-- table body start --> */}
                    <tbody class="divide-y divide-gray-100 ">
                      <tr class="whitespace-nowrap">
                      
                       
                         {/* <!-- SiNo--> */}
                        <td class="px-5 py-4 sm:px-6">
                          <div class="flex items-center">
                            <p class="text-black text-sm ">
                              1
                            </p>
                          </div>
                        </td>

                        {/* <!--Status--> */}
                        <td class="px-5 py-4 sm:px-6">
                              <div class="flex items-center">
                                <p
                                  class="rounded-full bg-[#047A48] px-2 py-0.5 text-sm font-medium text-white">
                                  Success
                                </p>
                              </div>
                            </td>

                        {/* <!-- Create ON--> */}
                        <td class="px-5 py-4 sm:px-6">
                          <div class="flex items-center">
                            <p class="text-black text-sm ">
                            Anderson
                            </p>
                          </div>
                        </td>
                        
                        {/* <!--Order ID--> */}
                        <td class="px-5 py-4 sm:px-6">
                          <div class="flex items-center">
                            <p class="text-black text-sm ">Axis Bank</p>
                          </div>
                        </td>
              
                        {/* <!--Reference--> */}
                        <td class="px-5 py-4 sm:px-6">
                          <div class="flex items-center">
                            <p class="text-black text-sm ">1278687682374</p>
                          </div>
                        </td>  

                        {/* <!--Name--> */}
                        <td class="px-5 py-4 sm:px-6">
                          <div class="flex items-center">
                            <p class="text-black text-sm ">ABd123Rf</p>
                          </div>
                        </td>        
              
                        {/* <!--Amount--> */}
                        <td class="px-5 py-4 sm:px-6">
                          <div class="flex items-center">
                            <p class="text-black text-sm ">26 Jul, 2024, 6:53 19</p>
                          </div>
                        </td>
              
                        

                          
                      </tr>

                      
                    </tbody>
                  </table>
                </div>
              </div>
              


                {/* <!-- Table End --> */}
            </div>
        </div>
    </div>
</div>


      
    </div>
  </main>
  )
}

export default beneficaries